import React, { useContext } from 'react';

import CardContext from 'contexts/CardContext';
import { CardSkeleton } from '../../Skeleton';
import useStackedBarData from './useStackedBarData';
import StackedBarView from './StackedBarView';

const StackedBarContent = ({
  chartDefinition,
  chartRef,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
}) => {
  const { i } = useContext(CardContext);
  const { options, groupKey } = useStackedBarData({
    chartDefinition,
    chartRef,
  });

  if (groupKey === undefined) {
    throw new Error(
      `Group key not found for chartDefId: ${chartDefinition.id}`,
    );
  }

  if (!options) {
    return <CardSkeleton />;
  }

  return (
    <StackedBarView chartRef={chartRef} options={options} remountKey={i} />
  );
};

export default StackedBarContent;
